import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';

import CellList from '../CellList';
import NumberColumn from '../NumberColumn';

import styles from './TableRowItem.module.scss';
import usePresenter from './TableRowItem.presenter';
import getProps from './TableRowItem.props';
import { TableRowItemCombinedProps } from './types';


// MANUAL OVERRIDE - converted to observer Component
const TableRowItem: React.FC<TableRowItemCombinedProps> = observer((props) => {
  const {
    className,
    classes,
    numberColumn,
    cellList,
    handleMouseEnter, // MANUAL OVERRIDE
    handleMouseLeave, // MANUAL OVERRIDE
  } = usePresenter(props);

  const variantName = '';
  const internalProps = getProps(variantName);
  const currentStyle = styles[`tableRowItem${variantName}`];

  let componentView;

  switch (variantName) {
    case '': {
      componentView = (
        <div
          className={cx(currentStyle, className)}
          onMouseEnter={handleMouseEnter} // MANUAL OVERRIDE
          onMouseLeave={handleMouseLeave} // MANUAL OVERRIDE
        >
          <NumberColumn
            className={cx(styles.numberColumn, classes?.numberColumn)}
            {...internalProps.numberColumn}
            {...numberColumn}
          />
          <CellList
            className={cx(styles.cellList, classes?.cellList)}
            {...internalProps.cellList}
            {...cellList}
          />
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
}); // MANUAL OVERRIDE

export default TableRowItem;
